import React from 'react';
import PropTypes from 'prop-types';
const filter = require('lodash/filter');
import { Modal, Button, Form } from 'react-bootstrap';

const Globals = require('../../../../app/globals');
const KeyboardUtil = require('../../util/keyboard');
const PermissionsUtil = require('../../../../app/shared/PermissionsUtil');
import ErrorBox from '../common/ErrorBox';
import DistributionRestrictionWarningBox from '../common/DistributionRestrictionWarningBox';
const ChannelStore = require('../../stores/channel_store_reflux');
import ChannelFolderTree from '../common/Tree/ChannelFolderTree';

const propTypes = {
    project: PropTypes.object.isRequired,
    submitHandler: PropTypes.func.isRequired,
    closeHandler: PropTypes.func.isRequired,
    show: PropTypes.bool,
    multiline: PropTypes.bool,
    error: PropTypes.object,
    disabled: PropTypes.bool,
    distributionRestrictedActivities: PropTypes.array,
};

const defaultProps = {
    multiline: false,
    error: null,
    diabled: false,
    distributionRestrictedActivities: [],
};

class CopyProjectModal extends React.Component {
    constructor(props) {
        super(props)
        const channelStoreState = ChannelStore.getState();
        this.getTargetChannels = this.getTargetChannels.bind(this);
        this.state = {
            inputValue: props.project.name + " Copy",
            channelStoreState: channelStoreState,
            targetChannels: this.getTargetChannels(channelStoreState),
            selectedChannelId: null,
            selectedFolderId: null,
        };
        this.inputElem = React.createRef();
        this.focusOnInput = this.focusOnInput.bind(this);
        this.onChangeInput = this.onChangeInput.bind(this);
        this.onDistributionWarningCheck = this.onDistributionWarningCheck.bind(this);
        this.submitHandler = this.submitHandler.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.onSelectChannel = this.onSelectChannel.bind(this);
        this.onSelectFolder = this.onSelectFolder.bind(this);
        this.unsubscribes = [ChannelStore.listen(this.onChannelStoreChange.bind(this))];
    }

    componentDidMount() {
        this.focusOnInput();
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    getTargetChannels(channelStoreState) {
        if (channelStoreState.channelsAndOrgs) {
            const pChannelId = parseInt(this.props.project.channelId, 10);
            return filter(channelStoreState.channelsAndOrgs, (c) => {
                return (
                    PermissionsUtil.canCreateProject(c.user_permissions)
                    && (this.props.project.content_type !== Globals.content_type.COURSE || c.id === pChannelId)
                );
            });
        }

        return [];
    }

    focusOnInput() {
        const inputElem = this.inputElem.current;
        if (!inputElem) {
            return;
        }

        inputElem.focus();
        if (!!this.props.defaultValue) {
            inputElem.setSelectionRange(0, inputElem.value.length);
        }
    }

    onChannelStoreChange(channelStoreState) {
        let newState = {
            channelStoreState: channelStoreState,
            targetChannels: this.getTargetChannels(channelStoreState),
        };

        this.setState(newState);
    }

    onChangeInput(e) {
        e.stopPropagation();
        this.setState({ inputValue: e.target.value });
    }

    onDistributionWarningCheck(val) {
        this.setState({ warningAccepted: val });
    }

    submitHandler() {
        this.props.submitHandler(this.state.inputValue, this.state.selectedChannelId, this.state.selectedFolderId);
    }

    handleKeyDown(e) {
        e.stopPropagation();
        if (!this.props.multiline && KeyboardUtil.isEnterKey(e.keyCode)) {
            this.submitHandler();
        }
    }

    onSelectChannel(channelId) {
        this.setState({ selectedChannelId: channelId, selectedFolderId: null });
    }

    onSelectFolder(folderId) {
        this.setState({ selectedFolderId: folderId, selectedChannelId: null });
    }

    render() {
        let channelPicker;
        if (this.state.targetChannels.length > 0) {
            let folders;
            let foldersFlat;
            if (this.props.project.content_type === Globals.content_type.ACTIVITY) {
                folders = this.state.channelStoreState.folders;
                foldersFlat = this.state.channelStoreState.foldersFlat;
            }
            else if (this.props.project.content_type === Globals.content_type.COURSE) {
                folders = this.state.channelStoreState.shortCourseFolders;
                foldersFlat = this.state.channelStoreState.shortCourseFoldersFlat;
            }

            channelPicker = (
                <Form.Group>
                    <Form.Label htmlFor="copy-project-channel-tree">Select destination</Form.Label>
                    <ChannelFolderTree
                        id="copy-project-channel-tree"
                        className="margin-top-md"
                        channels={this.state.targetChannels}
                        folders={folders}
                        foldersFlat={foldersFlat}
                        selectedChannelId={this.state.selectedChannelId}
                        selectedFolderId={this.state.selectedFolderId}
                        selectedFolder={this.state.selectedFolder}
                        onSelectChannel={this.onSelectChannel}
                        onSelectFolder={this.onSelectFolder}
                    />
                </Form.Group>
            );
        }
        else {
            channelPicker = <ErrorBox error={{ message: 'No destination channels available'}} />;
        }

        return (
            <Modal
                className='single-input-modal'
                show={this.props.show}
                enforceFocus={false}
                backdrop={false}
                animation={false}
                keyboard
                onHide={this.props.closeHandler}
            >
                <Modal.Header closeButton onHide={this.props.closeHandler}>
                    <Modal.Title>Copy Project</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ErrorBox error={this.props.error} />
                    {(!!this.props.distributionRestrictedActivities && this.props.distributionRestrictedActivities.length > 0) &&
                        <DistributionRestrictionWarningBox
                            className="font-size-md"
                            distributionRestrictedActivities={this.props.distributionRestrictedActivities}
                            onChangeAcceptance={this.onDistributionWarningCheck}
                        />
                    }
                    <Form>
                        <Form.Group controlId="copy-proj-modal-input">
                            <Form.Label>project copy name</Form.Label>
                            <Form.Control
                                as={this.props.multiline ? 'textarea' : 'input'}
                                ref={this.inputElem}
                                aria-label="project copy name"
                                value={this.state.inputValue}
                                onChange={this.onChangeInput}
                                onKeyDown={this.handleKeyDown}
                            />
                        </Form.Group>
                        {channelPicker}
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        disabled={
                            this.props.disabled
                            || !this.state.inputValue
                            || (!this.state.selectedChannelId && !this.state.selectedFolderId)
                            || (this.props.distributionRestrictedActivities && this.props.distributionRestrictedActivities.length && !this.state.warningAccepted)
                        }
                        onClick={this.submitHandler}
                    >
                        copy
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default CopyProjectModal;

CopyProjectModal.propTypes = propTypes;
CopyProjectModal.defaultProps = defaultProps;
